// const findingsData = [
//   "Normal Sinus Rhythm",
//   "Sinus Rhythm",
//   "Sinus Bradycardia",
//   "Sinus Tachycardia",
//   "Sinus Arrhythmia",
//   "Supraventricular Tachycardia",
//   "Atrial Fibrillation",
//   "Atrial Flutter",
//   "J Point Elevation",
//   "ST Depression",
//   "T Wave Inversion",
//   "ST Depression and T-wave Inversion",
//   "R/S : > 1",
//   "Biphasic T waves",
//   "Possible Ischemia",
//   "Ventricular Bigeminy",
//   "Ventricular Trigeminy",
//   "Paced Rhythm",
//   "First Degree AV Block",
//   "Mobitz Type 1 AV Block",
//   "Mobitz Type II AV Block",
//   "Third Degree Complete Block",
//   "Ventricular Tachycardia",
//   "PAC",
//   "VPC",
//   "Junctional Rhythms",
//   "Ventricular Couplets",
//   "Anterolateral MI",
//   "Anteroseptal MI",
//   "Antero - Apical MI",
//   "Anterior Wall MI",
//   "Inferior MI",
//   "Infero Lateral MI",
//   "Infero Septal MI",
//   "Lateral Wall MI",
//   "Left Bundle Branch Block (LBBB)",
//   "Right Bundle Branch Block (RBBB)",
//   "Ischemia",
//   "RVH",
//   "WPW Syndrome",
//   "Baseline Wandering Artifact",
//   "AC Interference Artifact",
//   "Muscle Tremor Artifact"
// ];

// export default findingsData;

const findingsData = [
  { _id: "65b8f1a1c1a4b001a1a20001", name: "Normal Sinus Rhythm", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20002", name: "Sinus Rhythm", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20003", name: "Sinus Bradycardia", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20004", name: "Sinus Tachycardia", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20005", name: "Sinus Arrhythmia", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20006", name: "Supraventricular Tachycardia", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20007", name: "Atrial Fibrillation", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20008", name: "Atrial Flutter", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20009", name: "J Point Elevation", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20010", name: "ST Depression", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20011", name: "T Wave Inversion", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20012", name: "ST Depression and T-wave Inversion", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20013", name: "R/S : > 1", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20014", name: "Biphasic T waves", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20015", name: "Possible Ischemia", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20016", name: "Ventricular Bigeminy", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20017", name: "Ventricular Trigeminy", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20018", name: "Paced Rhythm", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20019", name: "First Degree AV Block", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20020", name: "Mobitz Type 1 AV Block", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20021", name: "Mobitz Type II AV Block", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20022", name: "Complete Heart Block", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20023", name: "Ventricular Tachycardia", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20024", name: "Premature Atrial Complex (PAC)", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20025", name: "Premature Ventricular Complex (PVC)", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20026", name: "Junctional Rhythm", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20027", name: "Ventricular Couplets", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20028", name: "Anterolateral MI", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20029", name: "Anteroseptal MI", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20030", name: "Antero - Apical MI", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20031", name: "Anterior Wall MI", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20032", name: "Inferior MI", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20033", name: "Infero Lateral MI", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20034", name: "Lateral Wall MI", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20035", name: "Left Bundle Branch Block (LBBB)", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20036", name: "Right Bundle Branch Block (RBBB)", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20037", name: "Ischemia", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20038", name: "WPW Syndrome", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20039", name: "Baseline Wandering Artefact", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20040", name: "AC Interference Artefact", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20041", name: "Muscle Tremor Artefact", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20042", name: "Old MI", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20043", name: "Junctional Tachycardia", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20044", name: "Idioventricular Rhythm", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20045", name: "Accelerated Junctional Rhythm", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20046", name: "Poor R-wave Progression", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20047", name: "ST-Elevation", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20048", name: "Premature Junctional Complex (PJC)", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20049", name: "Accelerated Idioventricular Rhythm", leads: [] },
  { _id: "65b8f1a1c1a4b001a1a20050", name: "Reconstruction Issue", leads: [] },
];

export default findingsData;


